import get from 'lodash/get'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import { airTransformedAirPriceQuery } from './queries/airPriceRespQuery'
import { airPriceFireFlyQuery } from '../../../common/services/airPrice'

export function graphAirPriceCall({ params = {}, isFireflyRequest, query }) {
  params.productId = 1
  params.requestId = params.requestId || uuid()

  let GRAPH_QUERY
  if (query) {
    GRAPH_QUERY = query
  } else {
    GRAPH_QUERY = isFireflyRequest
      ? airPriceFireFlyQuery
      : airTransformedAirPriceQuery
  }

  return new Promise((resolve, reject) => {
    axios({
      url: window.PCLN_BOOTSTRAP_DATA.useLocalFlyql
        ? 'http://localhost:3059/fly-ql/graph/query'
        : '/pws/v0/pcln-graph/',
      data: {
        operationName: 'airPriceResponse',
        variables: { input: params },
        query: GRAPH_QUERY,
      },
      method: 'post',
      headers: {
        'apollographql-client-name': 'fly-graph',
        'apollographql-client-version': get(
          window,
          'PCLN_BOOTSTRAP_DATA.appInfo.appVersion',
          'development'
        ),
        'x-pcln-search-source':
          'appname:mflysearch-pagename:details-searchtype:ugs',
      },
    })
      .then(priceResponseResult => {
        const error =
          get(priceResponseResult, 'data.data.airPriceResponse.error', '') ||
          get(priceResponseResult, 'data.errors[0]', '')
        if (error) {
          reject(error)
        }
        resolve({
          request: params,
          rawResponse: get(
            priceResponseResult,
            'data.data.airPriceResponse.rawResponse.airPriceRsp',
            {}
          ),
          graphResponse: get(
            priceResponseResult,
            'data.data.airPriceResponse',
            {}
          ),
        })
      })
      .catch(error => {
        reject(error)
      })
  })
}
